import { memo } from "react";
import { useSelector } from "react-redux";
import SoftBox from "components/SoftBox";
import { Handle, Position } from "reactflow";
import classNames from "classnames";
import defaultConnectorIcon from "assets/images/connector.png";

function SubFlowNode({ data }) {
  const { isVerticalCanvasDirection } = useSelector((state) => state?.designer?.settings);
  const { flows } = useSelector((state) => state?.designer?.flows);

  const subFlowNodeFlow = flows.find((flow) => flow.id === data?.flowId);
  const subFlowNodeFlowLogo = subFlowNodeFlow?.logo;

  const handleClass = classNames({
    "node-handle": true
  });

  const handleOpenSubFlow = (event) => {
    event.stopPropagation();
    window.open(`/designer/${subFlowNodeFlow.id}`, "_blank");
  };

  return (
    <SoftBox
      className={`custom-node-wrapper custom-node-wrapper-cover connector-node ${data?.isDisabled ? "disabled-node" : ""}`}
      sx={{
        position: "relative",
        display: "flex",
        minHeight: "54px",
        overflow: "hidden"
      }}
      onClick={handleOpenSubFlow}
    >
      <img
        style={{
          objectFit: "cover",
          width: "54px",
          height: "100%"
        }}
        src={subFlowNodeFlowLogo ? subFlowNodeFlowLogo : defaultConnectorIcon}
        alt={subFlowNodeFlow?.name}
      />
      <div className="custom-node-text">
        <p className="label-text">{subFlowNodeFlow?.name}</p>
      </div>
      {isVerticalCanvasDirection ? (
        <Handle className={handleClass} type="target" position={Position.Right} />
      ) : (
        <Handle className={handleClass} type="target" position={Position.Top} />
      )}
    </SoftBox>
  );
}
export default memo(SubFlowNode);
